// Configuration for the application
export const config = {
  // LogRocket configuration
  logRocket: {
    appId: 'xfo9gq/habitat-evals', // Replace with your actual LogRocket app ID
    // Enable LogRocket only in production or when explicitly enabled
    enabled: true // Hardcoded to true to enable LogRocket
  }
};